import React from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import WeekPlanChart from "../../../components/WeekPlanChart";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { nextPageRoute } from "../../../utils/modules";

const imagesToPreload = {
  male: [
    "/payment/apple-pay.svg",
    "/payment/male-transform.png",
    "/payment/ng-arrows.svg",
    "/payment/flex-low.svg",
    "/payment/flex-high.svg",
    "/payment/income-low.svg",
    "/payment/income-high.svg",
    "/payment/green-tick.svg",
    "/payment/male.jpg",
  ],
  female: [
    "/payment/apple-pay.svg",
    "/payment/female-transform.png",
    "/payment/ng-arrows.svg",
    "/payment/flex-low.svg",
    "/payment/flex-high.svg",
    "/payment/income-low.svg",
    "/payment/income-high.svg",
    "/payment/green-tick.svg",
    "/payment/female.jpg",
  ],
};

const WeekPlan = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const email = location?.state;
  const dispatch = useDispatch();
  const navigateToNext = (route) => {
    navigate("/payment", {
      state: { email: email, gender: params.gender },
    });
  };
  const nextPage = async () => {
    nextPageRoute(
      navigateToNext,
      "/payment",
      dispatch,
      imagesToPreload[params.gender || "female"]
    );
  };

  return (
    <MobileViewLayout>
      <div className="flex-grow-1 px-4">
        <h1 className="fw-bold text-center fs30" style={{ marginTop: "60px" }}>
          <Trans i18nKey={"career_plan_ready.title"} />
        </h1>

        <div className="w-100">
          <p className="fw-bold text-center fs18" style={{ marginTop: "10px" }}>
            <Trans i18nKey={"career_plan_ready.readiness_level"} />
          </p>
          <div className="w-100 px-1">
            <WeekPlanChart />
          </div>
        </div>
        <Button
          onClick={nextPage}
          className="w-100 fw-semibold fs18 bgSecondary sticky-button"
          style={{
            marginTop: "40px",
            marginBottom: "18px",
            padding: "15px 0px",
            height: "60px",
          }}
        >
          <Trans i18nKey={"common_text.continue"} />
        </Button>
      </div>
    </MobileViewLayout>
  );
};

export default WeekPlan;
